var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAtSign = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    fillRule: "evenodd",
    fill: "none",
    id: "NeoPro---User-settings"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fillRule: "nonzero",
    fill: "currentColor",
    id: "@",
    d: "m10.75354,16.59231c1.11569,0 2.12585,-0.21108 3.136,-0.75385l-0.37692,-0.82923c-0.85938,0.46738 -1.79415,0.69354 -2.75908,0.69354c-2.65354,0 -4.28185,-1.65846 -4.28185,-4.62862c0,-2.72892 1.77908,-4.59846 4.22154,-4.59846c2.62338,0 4.20646,1.68862 4.20646,4.35723c0,1.59815 -0.40708,2.42738 -1.176,2.42738c-0.588,0 -0.82923,-0.27138 -0.82923,-1.176l0,-2.05046c0,-1.23631 -0.82923,-2.00523 -2.02031,-2.00523c-1.29662,0 -2.12585,0.72369 -2.32185,1.91477l1.04031,0.18092c0.13569,-0.72369 0.54277,-1.11569 1.28154,-1.11569c0.49754,0 0.90462,0.27138 0.90462,0.69354c0,0.46738 -0.30154,0.61815 -1.58308,0.99508c-1.19108,0.36185 -1.68862,0.88954 -1.68862,1.77908c0,1.08554 0.784,1.71877 1.89969,1.71877c0.72369,0 1.41723,-0.28646 1.77908,-0.81415l0.03015,0c0.24123,0.51262 0.70862,0.784 1.43231,0.784c1.43231,0 2.21631,-1.11569 2.21631,-3.332c0,-3.09077 -1.96,-5.24677 -5.17138,-5.24677c-3.01538,0 -5.17138,2.32185 -5.17138,5.488c0,3.46769 2.03538,5.51815 5.23169,5.51815zm-0.24123,-3.37723c-0.57292,0 -0.90462,-0.27138 -0.90462,-0.79908c0,-0.40708 0.22615,-0.66338 0.91969,-0.87446c0.79908,-0.24123 1.14585,-0.43723 1.23631,-0.64831l0.03015,0l0,1.20615c0,0.67846 -0.54277,1.11569 -1.28154,1.11569z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    id: "Stroke-5",
    d: "m19.46154,11.15385c0,4.75785 -3.85754,8.61539 -8.61539,8.61539c-4.75785,0 -8.61539,-3.85754 -8.61539,-8.61539c0,-4.75785 3.85754,-8.61539 8.61539,-8.61539c4.75785,0 8.61539,3.85754 8.61539,8.61539z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAtSign, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AtSign.b901392e.svg";
export { ForwardRef as ReactComponent };